import axios from '../utils/APIUtils';
import { OPPORTUNITIES_API_PATHS ,PROFILES_API_PATHS} from '../constants/constants';
import { IOpportunityDetailItemModel, IReasonsModel,IGetProfile,ISamplingCountAPIModel } from '../models/IOpportunitiesAPIModel';
import {buildFilterRequest} from '../slices/allOpportunitySlice';
import { ISortModel } from '../models/IAllOpportunitiesModel';
import {  buildFilterRequest as buildFilterRequestSampling } from '../slices/samplingSlice';
import {  buildFilterRequest as buildFilterRequestOrphan } from '../slices/orphanSlice';
import { UserManager } from '@forge/sso-client';
import { isAks } from '../utils/properties/UrlsAndEnvProperties';

 /** Get opportunity details */
export const getOpportunitiesDetail = async (opportunityId: number,currentRole:string) => {
    return await axios.post<IOpportunityDetailItemModel>
        (`${OPPORTUNITIES_API_PATHS.opportunities}/${opportunityId}`,{"current_role":currentRole})
        .then((response) => {
            return response.data;
    }).catch(err => {
        console.log('Opportunity API error ', err);
        throw err;
    });
};

/** Get user action details */
export const getUserAction = async (opportunityId: number) => {
    return await axios.get<IOpportunityDetailItemModel>
        (`${OPPORTUNITIES_API_PATHS.opportunities}/${opportunityId}/action`)
        .then((response) => {
            return response.data;
    }).catch(err => {
        console.log('getUserAction API error ', err);
        throw err;
    });
};

/** Reasons API for action and no action*/
export const getReasons = async (opportunityId: number,action_type:string) => {
    return await axios.get<IReasonsModel[]>
        (`${OPPORTUNITIES_API_PATHS.opportunities}/${opportunityId}/reasons?action_type=${action_type}`)
        .then((response) => {
            return response.data;
    }).catch(err => {
        console.log('getReasons API error ', err);
        throw err;
    });
};

/** Reviewer Checklist   */


export const getChecklist = async (opportunityId: number,currentRole:string) => {
    return await axios.get<IReasonsModel[]>
        (`${OPPORTUNITIES_API_PATHS.opportunities}/checklist?current_role=${currentRole}&insight_id=${opportunityId}`)
        .then((response) => {
            return response.data;
    }).catch(err => {
        console.log('getReasons API error ', err);
        throw err;
    });
};


export const reviewerChecklistSave = (anomalyId:any,data:any) => {
    return axios.post<any>
        (`${OPPORTUNITIES_API_PATHS.opportunities}/${anomalyId}/user-response`,data)
        .then((response) => {
            return response.data;
    })
};

/** Submit tracking API - captures org user response along with action owner(s) assignment (share_to) */
export const submitTracking = async (anomalyId: any, data: any) => {
    const userManager = UserManager.getInstance();
    const user = await userManager.getUser();
    return await axios.post<any>
        (`${OPPORTUNITIES_API_PATHS.opportunities}/${anomalyId}/submit-tracking`, data, {
            headers: {
                'x-id-token': `Bearer ${isAks() ? sessionStorage.getItem("idToken") : (user)?.id_token}`
            }
        })
        .then((response) => {
            return response.data;
    }).catch(err => {
        console.log('submitTracking API error ', err);
        throw err;
    });
};

/** Training options for the reviewer checklist dropdown */
export const getTrainingOptions = async () => {
    return await axios.get<any[]>
        (`${OPPORTUNITIES_API_PATHS.trainingOptions}`)
        .then((response) => {
            return response.data;
    }).catch(err => {
        console.log('getTrainingOptions API error ', err);
        throw err;
    });
};

/** Inserts a proposed action tracking record for the training assigned to the action owner, triggered on submit of review */
export const insertActionTracking = (anomalyId: any, data: any) => {
    return axios.post<any>
        (`${OPPORTUNITIES_API_PATHS.opportunities}/${anomalyId}/action-tracking`, data)
        .then((response) => {
            return response.data;
    }).catch(err => {
        console.log('insertActionTracking API error ', err);
        throw err;
    });
};

/** Bulk-saves the reviewer's proposed action tracking rows (one per reason) with status = proposed, in a single call */
export const saveProposedActionTracking = (anomalyId: any, trackingInfo: any[]) => {
    return axios.post<any[]>
        (`${OPPORTUNITIES_API_PATHS.opportunities}/${anomalyId}/action-tracking-proposed`, { is_proposed: true, tracking_info: trackingInfo })
        .then((response) => {
            return response.data;
    }).catch(err => {
        console.log('saveProposedActionTracking API error ', err);
        throw err;
    });
};

/** Fetches the reviewer's proposed action tracking record(s) (status = proposed) for the org owner screen */
export const getProposedActionTracking = (anomalyId: any) => {
    return axios.get<any[]>
        (`${OPPORTUNITIES_API_PATHS.opportunities}/${anomalyId}/proposed-action-tracking`)
        .then((response) => {
            return response.data;
    }).catch(err => {
        console.log('getProposedActionTracking API error ', err);
        throw err;
    });
};


/** Download opportunity details */
export const downloadAllOpportunity = async (filters:any,pagination:any,totalRecord:number,eid:string,roles:string,gridSort:ISortModel,isSampling:boolean=false,dataother:any,quickSumType:string,current_role:string,isOrphan:boolean,postFilters:Array<any>=[]) => {
    return new Promise((resolve, reject) => {
        try{
            let data: any = {};
            if(isSampling){
                data = buildFilterRequestSampling(filters, pagination,roles,gridSort,current_role);
            }else if(isOrphan){
                data = buildFilterRequestOrphan(filters, pagination,roles,gridSort,current_role);
                data["orphan"]=true;
            }
            
            else if(dataother["view_type"]!==undefined){
                data = buildFilterRequest(filters, pagination,gridSort,quickSumType,current_role,postFilters);
                data.view_type=dataother.view_type;
            }else{
                data = buildFilterRequest(filters, pagination,gridSort,quickSumType,current_role,postFilters);
            }
            data.page = 1;
            data.rows_per_page = totalRecord;  
            axios.post
                (`${OPPORTUNITIES_API_PATHS.export}`,data)
                .then((response) => {
                    var anchor = document.createElement('a');
                    var element = document.getElementsByTagName("BODY")[0];
                    element.appendChild(anchor);
            anchor.setAttribute("href", `data:attachment/csv;charset=utf-8, ${encodeURIComponent(response.data)}`);
            anchor.setAttribute("download",`all_anomalies_${eid}.csv`);
            anchor.click();
            anchor.remove();
            resolve(response.status); 
            }).catch(err => {
                console.log('Export API error ', err);
                reject(null);
            });
        } catch (error){
            reject(null);
        }      
    });
};


export const getAutoSearchForOpportunity = async (searchText: string,sampling:boolean=false,current_role:string="",orphan:boolean=false,postFilters:Array<any>=[]) => {
    const postData = {
        searchText,
        sampling,
        current_role,
        orphan,
        ...(postFilters.length>0 ? {postFilters} : {})
      };
    return new Promise((resolve, reject) => {
            axios.post<any>
                (OPPORTUNITIES_API_PATHS.autoCompelte, postData)
                .then((response) => {
                    resolve(response.data);
                }).catch(err => {
                    console.log('Opportunity API error ', err);
                    reject(null);
                });
    });
};

export const getProfileDetails = async (email: string) => {
    return await axios.get<IGetProfile>
        (`${PROFILES_API_PATHS.profiles}?search=${email}`)
        .then((response) => {
            return response.data;
    }).catch(err => {
        console.log('Opportunity API error ', err);
        throw err;
    });
};

// getStatusCount 
export const getStatusCount = async (current_role: string) => {
    return await axios.post<ISamplingCountAPIModel>
        (`${OPPORTUNITIES_API_PATHS.samplingCount}`, {current_role})
        .then((response) => {
            return response.data.totalCount;
    }).catch(err => {
        console.log('StatusCount API error ', err);
        throw err;
    });
};


export const getFilterOptions = async (data:any) => {
    return await axios.post<any>
        (OPPORTUNITIES_API_PATHS.anomalyFilter,data)
        .then((response) => {
            return response.data;
    }).catch(err => {
        console.log('Filter Option API error ', err);
        throw err;
    });
};

/** getFiles details API for action required*/
export const getUploadedFiles = async (opportunityId: number) => {
    return await axios.get<IReasonsModel[]>
        (`${OPPORTUNITIES_API_PATHS.opportunities}/${opportunityId}/user-activity`)
        .then((response) => {
            return response.data;
    }).catch(err => {
        console.log('get uploaded files API error ', err);
        throw err;
    });
};